import { useLocales } from 'src/locales';
import ProfessionalAssistantChat from 'src/sections/@dashboard/profile/components/ProfessionalAssistantChat';
import { GetVisitById } from 'woofwoof-api';
import { useVisitAssistantAction } from './VisitAssistantActionContext';

// ---------------------------------------------------------------------

type OrganizationVisitModalAssistantProps = {
  visit: GetVisitById;
  /**
   * Fill the parent's height (side panel, or the in-tab assistant in paper
   * mode). Pass false in body-scroll mode so the chat keeps its own bounded
   * 60vh scroll instead of collapsing in an unbounded container.
   */
  fillHeight?: boolean;
  /**
   * Move the chat scrollbar into the wrapper's existing gutter (panel edge)
   * instead of over the avatars. Only pass from the wide side panel, which has
   * a 24px (`p: 3`) gutter to absorb it.
   */
  edgeScrollbar?: boolean;
};

/**
 * "Asystent Vetsi" — the same visit-context assistant used on the live visit
 * page, available inside the OrganizationVisitModal for completed and confirmed-
 * upcoming visits (the 30-day edit window applies only to completed visits).
 * Always passes visitId so answers are
 * scoped to THIS visit's transcript + notes; the backend gates access to the
 * caller's active organization. Renders just the chat — the caller (side panel
 * or tab) owns padding/borders.
 */
export default function OrganizationVisitModalAssistant({
  visit,
  fillHeight = true,
  edgeScrollbar = false,
}: OrganizationVisitModalAssistantProps) {
  const { translate } = useLocales();
  const { patientNotesDraft, internalNotesDraft, dispatchAssistantAction } =
    useVisitAssistantAction();

  const isGuestVisit = !visit.profile?.id;
  const petName = visit.profile?.name ?? '';

  return isGuestVisit ? (
    <ProfessionalAssistantChat
      fillHeight={fillHeight}
      naturalOrder
      edgeScrollbar={edgeScrollbar}
      profileId=""
      profileName={petName}
      visitId={visit.id}
      initialContentOverride={
        visit.aiNote || String(translate('visit.aiNoteEmpty'))
      }
      patientNotesDraft={patientNotesDraft}
      internalNotesDraft={internalNotesDraft}
      onAssistantAction={dispatchAssistantAction}
    />
  ) : (
    <ProfessionalAssistantChat
      fillHeight={fillHeight}
      naturalOrder
      edgeScrollbar={edgeScrollbar}
      profileId={visit.profile!.id}
      profileName={visit.profile!.name}
      visitId={visit.id}
      patientNotesDraft={patientNotesDraft}
      internalNotesDraft={internalNotesDraft}
      onAssistantAction={dispatchAssistantAction}
    />
  );
}
